import script from "./edu2esc.vue?vue&type=script&lang=js"
export * from "./edu2esc.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__